import { render, staticRenderFns } from "./generalFooter.vue?vue&type=template&id=084088a6&scoped=true&"
import script from "./generalFooter.vue?vue&type=script&lang=js&"
export * from "./generalFooter.vue?vue&type=script&lang=js&"
import style0 from "./generalFooter.vue?vue&type=style&index=0&id=084088a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084088a6",
  null
  
)

export default component.exports